module.exports = __webpack_public_path__ + "static/img/Silver3.676626d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Silver3.svg
// module id = 35s+
// module chunks = 35